import { render } from "./ActiveTable.vue?vue&type=template&id=f134da20"
import script from "./ActiveTable.vue?vue&type=script&lang=js"
export * from "./ActiveTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__